// extracted by mini-css-extract-plugin
export default {"asterisco":"AsteriscoObligatorio_asterisco__5NfEU","asteriscoTransparente":"AsteriscoObligatorio_asteriscoTransparente__E0ZuU"};